import Vue from "vue";
import { orderBy } from "@progress/kendo-data-query";
import { filterBy, CompositeFilterDescriptor } from "@progress/kendo-data-query";
import moment from "moment";

export default {
	components: {},

	data: function() {
		return {
			defaultAddRow: null,
			isSortable: true,
			isFilterable: true,
			editItem: undefined,
			changes: false,
			updatedData: [],
			editID: null,
			editField: undefined,
			skip: 0,
			items: [],
			isInEditMode: false,
			hasSelectedMode: false,
			hasEditableMode: false,
			selectedField: "selected",
			updatedItems: [],
			createdItems: [],
			deletedItems: [],
			take: 1000000,
			pageable: {
				buttonCount: 5,
				info: true,
				type: "numeric",
				pageSizes: false,
				previousNext: true
			},
			indexNewItem: 0,
			sort: [],
			columnFilters: [
				// {
				// 	field: "",
				// 	filter: {
				// 		logic: "or",
				// 		filters: []
				// 	}
				// }
			],
			itemToReturnIfIsInEditMode: []
		};
	},

	created() {},

	watch: {
		isInEditMode() {
			this.isSortable = !this.isInEditMode;
			this.isFilterable = !this.isInEditMode;
		}
	},

	methods: {
		removeFilter(e) {
			if (e) {
				var findFilterIndex = this.columnFilters.findIndex(function(item) {
					return item.field === e.field;
				});

				if (findFilterIndex >= 0) {
					this.columnFilters.splice(findFilterIndex, 1);

					if (this.internalFiltersToUpdate) {
						this.internalFiltersToUpdate(e);
					}

					this.$emit("filter-removed", e.field);
					this.$emit("grid-header-filter", this.columnFilters);
				}
			}
		},
		filterHandler(e, notFireEvent) {
			if (e) {
				var findFilterIndex = this.columnFilters.findIndex(function(item) {
					return item.field === e.field;
				});

				if (findFilterIndex >= 0) {
					this.columnFilters.splice(findFilterIndex, 1);
				}

				if (e.filterType == "multiselect" && e.filterItemsSelected.length > 0) {
					var filtersToAdd = {
						field: e.field,
						type: "multiselect",
						filter: {
							logic: "or",
							filters: []
						}
					};

					for (var i = 0; i < e.filterItemsSelected.length; i++) {
						var f = e.filterItemsSelected[i];
						filtersToAdd.filter.filters.push({
							field: e.field,
							operator: "contains",
							value: f
						});
					}

					this.columnFilters.push(filtersToAdd);
				} else if (e.filterType == "datetimerange" || e.filterType == "daterange") {
					this.columnFilters.push({
						field: e.field,
						type: "datetime",
						filter: {
							logic: "and",
							filters: [
								{
									field: e.field,
									operator: "gte",
									value: e.startDateHeader
								},
								{
									field: e.field,
									operator: "lte",
									value: e.endDateHeader
								}
							]
						}
					});
				} else if (e.filterType == "boolean") {
					this.columnFilters.push({
						field: e.field,
						type: "boolean",
						filter: {
							logic: "and",
							filters: [
								{
									field: e.field,
									operator: "eq",
									value: e.filterRadioButtonSelected
								}
							]
						}
					});
				} else if (e.filterText) {
					this.columnFilters.push({
						field: e.field,
						type: "text",
						filter: {
							logic: "and",
							filters: [
								{
									field: e.field,
									operator: "contains",
									value: e.filterText
								}
							]
						}
					});
				} else {
					this.removeFilter(e);
				}

				if (this.internalFiltersAddToUpdate) {
					this.internalFiltersAddToUpdate(e);
				}

				this.$emit("grid-header-filter", this.columnFilters);
			}
		},
		documentClick() {
			/*
            this.items.forEach((d) => {
                if (d.inEdit) {
                        console.log("rowchange");
                        Vue.set(d, 'inEdit', undefined);
                }
             });
            this.items = this.items;
            */
		},

		clearWorkingData() {
			this.createdItems = [];
			this.updatedItems = [];
			this.deletedItems = [];

			this.isInEditMode = false;
		},
		addItem() {
			if (!this.isInEditMode) return;

			this.exitEditCell();

			var addItemClone = this.cloneItem(this.defaultAddRow);

			this.createdItems.push(addItemClone);
			this.items.unshift(addItemClone);

			this.itemToReturnIfIsInEditMode.unshift(addItemClone);

			this.indexNewItem--;
			this.defaultAddRow.id = this.indexNewItem;
		},
		remove(e) {
			if (!this.isInEditMode) return;

			if (e.dataItem.id <= 0) {
				var newItemIndex = this.createdItems.findIndex(function(item) {
					return item.id === e.dataItem.id;
				});

				this.createdItems.splice(newItemIndex, 1);
			} else {
				var itemToRemove = this.items.find(function(it) {
					return it.id === e.dataItem.id;
				});
				this.deletedItems.push(itemToRemove);
				var itemIndexUpdatedToRemove = this.updatedItems.findIndex(function(it) {
					return it.id === e.dataItem.id;
				});
				if (itemIndexUpdatedToRemove >= 0) {
					this.updatedItems.splice(newItemIndex, 1);
				}
			}

			var itemIndex = this.items.findIndex(function(item) {
				return item.id === e.dataItem.id;
			});
			this.items.splice(itemIndex, 1);

			var ii = this.itemToReturnIfIsInEditMode.findIndex(function(item) {
				return item.id === e.dataItem.id;
			});
			this.itemToReturnIfIsInEditMode.splice(ii, 1);
		},

		cloneItem(item) {
			return Object.assign({}, item);
		},
		saveChanges() {
			this.items.splice(0, this.items.length, ...this.items);
			this.items = this.items.map(product => Object.assign({}, product));
			this.editField = undefined;
			this.changes = false;
		},
		cancelChanges() {
			this.items = this.items.map(product => Object.assign({}, product));
			this.changes = false;
		},
		exitEditCell: function() {
			this.items.forEach(d => {
				if (d.inEdit) {
					Vue.set(d, "inEdit", undefined);
				}
			});
			this.items = this.items;
			this.editField = undefined;
		},
		itemChange: function(e) {
			//Vue.set(e.dataItem, e.field, e.value);

			var item = this.items.find(function(it) {
				return it.id === e.dataItem.id;
			});

			var itemUpdated = this.updatedItems.find(function(it) {
				return it.id === e.dataItem.id;
			});

			if (e.dataItem.id > 0 && (this._.isNull(itemUpdated) === true || this._.isUndefined(itemUpdated) === true)) this.updatedItems.push(item);

			this.changes = true;
		},
		deSelectAllRow() {
			this.items.forEach(d => {
				if (d.selected) {
					Vue.set(d, "selected", undefined);
				}
			});
		},

		selectRow(dataItem) {
			this.items.forEach(d => {
				if (d.selected) {
					Vue.set(d, "selected", undefined);
				}
			});

			if (!this.isInEditMode && this.hasSelectedMode) {
				//Selected Mode
				Vue.set(dataItem, this.selectedField, !dataItem[this.selectedField]);
				dataItem.id;
			}
		},

		onRowClick: function(e) {
			if (this.hasSelectedMode) {
				this.selectRow(e.dataItem);
				this.$emit("selected-row", e.dataItem);
			}
		},

		cellClickHandler: function(e) {
			if (!this.isInEditMode) return;
			if (e.dataItem.inEdit && e.field === this.editField) {
				return;
			}
			this.editField = e.field;
			this.items = this.items;

			Vue.set(e.dataItem, "inEdit", e.field);

			this.items.forEach(d => {
				if (d.inEdit) {
					if (e.dataItem !== d) {
						Vue.set(d, "inEdit", undefined);
					}
				}
			});
			this.items = this.items;
		},
		pageChangeHandler: function(event) {
			this.skip = event.page.skip;
			this.take = event.page.take;
		},

		sortChangeHandler: function(e) {
			this.sort = e.sort;
		},

		headerClick: function(e) {
			if (this.sort && this.sort.length > 0) {
				var existFieldSorted = this.sort.find(function(f) {
					return f.field == e.field;
				});
				if (existFieldSorted) {
					if (existFieldSorted.dir == "asc") {
						existFieldSorted.dir = "desc";
					} else if (existFieldSorted.dir == "desc") {
						var findIndexOfField = this.sort.findIndex(function(f) {
							return f.field == e.field;
						});
						this.sort.splice(findIndexOfField, 1);
					}
				} else {
					this.sort.push({ field: e.field, dir: "asc" });
				}
			} else {
				this.sort = [{ field: e.field, dir: "asc" }];
			}
		}
	},

	computed: {
		total() {
			return this.gridData ? this.gridData.length : 0;
		},
		gridData() {
			if (!this.isInEditMode) {
				var itemsToReturn = this.externalItems || this.items;

				if (this.columnFilters && this.columnFilters.length > 0) {
					this.columnFilters.forEach(f => {
						if (f.type == "datetime") {
							var minDateFilter = f.filter.filters[0];
							var maxDateFilter = f.filter.filters[1];

							var minDate = null;
							if (minDateFilter.value) {
								minDate = moment(minDateFilter.value);
							}

							var maxDate = null;
							if (maxDateFilter.value) {
								maxDate = moment(maxDateFilter.value);
							}

							if (minDate && maxDate) {
								itemsToReturn = itemsToReturn.filter(item => {
									return item[f.field] && moment(item[f.field]) >= minDate && moment(item[f.field]) <= maxDate;
								});
							} else if (minDate) {
								itemsToReturn = itemsToReturn.filter(item => {
									return item[f.field] && moment(item[f.field]) >= minDate;
								});
							} else if (maxDate) {
								itemsToReturn = itemsToReturn.filter(item => {
									return item[f.field] && moment(item[f.field]) <= maxDate;
								});
							}
						} else {
							itemsToReturn = filterBy(itemsToReturn, f.filter);
						}
					});
				}

				if (this.sort) {
					if (Array.isArray(this.sort)) {
						itemsToReturn = orderBy(itemsToReturn, this.sort);
					} else {
						itemsToReturn = orderBy(itemsToReturn, [this.sort]);
					}
				}

				this.itemToReturnIfIsInEditMode = _.clone(itemsToReturn);
				return itemsToReturn.slice(this.skip, this.take + this.skip);
			} else {
				return this.itemToReturnIfIsInEditMode;
			}
		}
	}
};
